if (window.innerWidth < 800) {
    const waitForTabs = (element, callback) => {
        const maxWaitTime = 7000;
        const interval = 90;
        let elapsedTime = 0;

        const waitingInterval = setInterval(() => {
            const selector = document.querySelector(element);
            if (selector) {
                callback();
                clearInterval(waitingInterval);
            } else {
                elapsedTime += interval;
                if (elapsedTime >= maxWaitTime) {
                    clearInterval(waitingInterval);
                }
            }
        }, interval);
    };

    waitForTabs("#pogo-tabs", () => {
        const tabsCont = document.querySelector("#pogo-tabs")
        tabsCont.classList.add("PF-tabs-cont");
        const tabList = tabsCont.querySelector(".tabs");
        const panes = document.querySelectorAll(".tabs-content > *");
        const allLis = Array.from(tabList.children);
        const specsLi = allLis.find(li =>
            li.textContent.trim().toLowerCase() === "specs"
        );
        if (specsLi) {
            tabList.insertBefore(specsLi, tabList.firstChild);
        }
        setTimeout(() => {
            tabList.querySelectorAll("li a.active")
                .forEach(a => a.classList.remove("active"));
            panes.forEach(p => {
                p.classList.remove("active");
                p.style.display = "none";
            });
            if (specsLi) {
                const link = specsLi.querySelector("a");
                if (link) {
                    link.classList.add("active");
                    const selector = link.getAttribute("data-tab-value");
                    const pane = document.querySelector(selector);
                    if (pane) {
                        pane.classList.add("active");
                        pane.style.display = "block";
                    }
                }
            }
        }, 100);

        tabList.addEventListener("click", e => {
            const a = e.target.closest("a");
            if (!a) return;
            e.preventDefault();
            tabList.querySelectorAll("li a.active")
                .forEach(x => x.classList.remove("active"));
            panes.forEach(p => {
                p.classList.remove("active");
                p.style.display = "none";
            });
            a.classList.add("active");
            const selector = a.getAttribute("data-tab-value");
            const pane = document.querySelector(selector);
            if (pane) {
                pane.classList.add("active");
                pane.style.display = "block";
            }
        });
    });
}